import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql';
import { AccessStatus } from '@confluence/session-data/entry-points/SiteInformationQuery';

import {
	EDITION_AWARENESS_STANDARD_TO_PREMIUM_EXPERIMENT_PILL_DISMISSED,
	useConfluenceStandardToPremiumExperimentQuery,
} from './useConfluenceStandardToPremiumExperiment';

export async function preloadUseConfluenceStandardToPremiumExperimentQuery() {
	const { isLoggedIn, accessStatus } = getPreloaderFnContext();

	const isLicensed =
		accessStatus === AccessStatus.LICENSED_ADMIN_ACCESS ||
		accessStatus === AccessStatus.LICENSED_USE_ACCESS;

	if (!isLoggedIn || !isLicensed) {
		return;
	}

	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: useConfluenceStandardToPremiumExperimentQuery,
		variables: {
			key: EDITION_AWARENESS_STANDARD_TO_PREMIUM_EXPERIMENT_PILL_DISMISSED,
		},
	});
}
